import React from 'react';

const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 9999,
    background: 'rgba(0, 0, 0, 0.3)',
    minHeight: '100vh',
    minWidth: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const spinnerStyle = {
    fontSize: '3.5rem',
    color: '#fff'
};

export default function LoadingSpinner() {
    return (
        <div style={overlayStyle}>
            <i className="loading-spinner fa fa-spinner fa-spin" style={spinnerStyle}></i>
        </div>
    );
}